<template>
  <div>
    <div class="d-flex justify-end align-center pa-6">
      <v-spacer></v-spacer>
      <v-btn color="green" dark outlined @click="exportExcel">
        <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
      </v-btn>
    </div>
    <v-data-table
      class="px-6"
      :headers="headers"
      :items="boardingDateSessions"
      item-key="id"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
    >
      <template v-slot:[`item.date`]="{ item }">
        {{ item.date | ddmm }}
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on" style="text-decoration: none; white-space: nowrap">
              <router-link
                v-on="on"
                style="text-decoration: none; white-space: nowrap"
                :to="'/boarding-class-session/' + item.id"
              >
                {{ item.boardingClassTitle }}
              </router-link>
            </div>
          </template>
          <span>Xem buổi bán trú</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.totalCount`]="{ item }">{{ item.totalCount }} </template>
      <template v-slot:[`item.attendanceCount`]="{ item }"> {{ item.attendanceCount }}</template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          small
          style="margin: 0"
          class="white--text"
          v-if="item.status"
          :color="item.status | boardingClassSessionStatusColor"
          label
        >
          {{ item.status | boardingClassSessionStatusText }}
        </v-chip>
      </template>

      <template v-slot:[`item.updatedBy`]="{ item }">
        {{ item.updatedBy }}
      </template>

      <template v-slot:[`item.updatedAt`]="{ item }">
        {{ item.updatedAt | ddmmyyyy }}
      </template>
      <!-- Thao tác -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn icon color="primary">
          <router-link
            v-on="on"
            style="text-decoration: none; white-space: nowrap"
            :to="'/boarding-class-session/' + item.id"
          >
            <v-icon>mdi-eye-outline</v-icon></router-link
          >
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { BoardingClassSession } from '@/plugins/api'
import utils from '@/plugins/utils'
import moment from 'moment'

const defaultHeaders = [
  { text: 'Buổi', value: 'date', align: 'left', sortable: false, show: true },
  { text: 'Lớp bán trú', value: 'name', align: 'left', sortable: false, show: true },
  { text: 'Sĩ số', value: 'totalCount', align: 'left', sortable: false, show: true },
  { text: 'Có mặt', value: 'attendanceCount', align: 'left', sortable: false, show: true },
  { text: 'Vắng mặt', value: 'absentCount', align: 'left', sortable: false, show: true },
  { text: 'Có phép', value: 'excusedAbsentCount', align: 'left', sortable: false, show: true },
  { text: 'Không phép', value: 'unexcusedAbsentCount', align: 'left', sortable: false, show: true },
  { text: 'Trạng thái', value: 'status', align: 'left', sortable: false, show: true },
  { text: 'Điểm danh bởi', value: 'updatedBy', align: 'left', sortable: false, show: true },
  { text: 'Thời gian điểm danh', value: 'updatedAt', align: 'left', sortable: false, show: true },
  { text: 'Thao tác', value: 'actions', align: 'left', sortable: false, show: true },
]

export default {
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 5,
      },
      selectedboardingDateSession: null,
      addboardingDateSession: false,
      studentSearchParams: {},
      boardingDateSessions: [],
      classCount: 0,
      loading: false,
      dialog: false,
    }
  },
  props: {
    filters: Object,
  },
  components: {},
  computed: {
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số buổi mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
      }
      return footerOptions
    },
  },
  methods: {
    async searchboardingDateSessionClass() {
      this.$loading.active = true
      this.loading = true
      if (this.filters) {
        this.tableOptions.page = 1
      }
      try {
        this.boardingDateSessions = await BoardingClassSession.getBoardingClassSessionByDate({
          ...this.filters,
          ...this.pageSetting(),
        })
        this.classCount = this.boardingDateSessions.length
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần ngày bán trú')
        console.error(error)
      }
      this.loading = false
      this.$loading.active = false
    },
    pageSetting() {
      return {}
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = defaultHeaders
        const excelHeader = headers
          .map(({ text, value }) => ({ text, value }))
          .filter(excel => excel.value !== 'action')
        const res = await this.search({ ...this.filters, _start: 0, _limit: -1 })
        const list = res.reports
        const data = JSON.parse(JSON.stringify(list))
        const currDate = moment(this.filters.date_gte).utcOffset(7).format('DD/MM/YYYY')
        utils.exportExcel(data, excelHeader, `${currDate}_ChuyenCan`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
